<template>
  <div class="row f-row h-100 justify-content-center" v-show="showCalculator">
    <div
      class="col col-12 text-center progress-div"
      style="top: 85%;"
      v-if="newSelectedStrategy.showLoading"
    >
      <QSLoading
        :isLoading="newSelectedStrategy.showLoading"
        :size="40"
        :colorTheme="colorTheme"
      />
    </div>
    <div
      class="col col-12 h-100 text-center"
      v-if="!newSelectedStrategy.calculated"
    >
      <div
        class="row h-100 f-row justify-content-center"
        v-if="carouselPage === 0"
        style="font-size: 0.8rem"
      >
        <div class="col col-5 mt-1">
          Complete Step 1
          <br />
          for Strategy Development
        </div>
      </div>
      <div
        class="row h-100 f-row justify-content-center"
        style="font-size: 0.8rem"
        v-else
      >
        <span v-if="Object.entries(newSelectedStrategy).length === 0">
          Select a strategy
        </span>
        <div class="col col-5 mt-3" v-else>
          <button
            type="button"
            class="btn btn-strat"
            style="height: 30px"
            v-on:click="onUserValuate()"
          >
            Calculate:
            <span style="color: var(--textactive)">
              {{ newSelectedStrategy.name }}
            </span>
          </button>
        </div>
      </div>
    </div>

    <!-- ======================= CALCULATOR ======================= -->
    <div class="col col-11" v-else>
      <!-- ======================= FIRST TABLE ======================= -->
      <table
        class="table table-sm table-borderless strat-table table-txt-large"
        style="width: 100%;"
      >
        <tbody>
          <tr>
            <td colspan="2" class="text-left">
              Strategy:
              <span style="color: var(--textactive)">
                {{ newSelectedStrategy.name }}
              </span>
            </td>
            <td style="width: 30px;" class="text-center"></td>
            <td colspan="2" v-show="isFwdOrFuture"></td>
            <td class="text-right">
              Cost: {{ newSelectedStrategy.costPerc }}%
            </td>
            <td class="text-right mr-1">Cost ({{ baseCurrency.base }}):</td>
            <td>
              <span v-if="newSelectedStrategy.cost === null">
                <div class="opt-table-txt">0</div>
              </span>
              <span v-else
                ><InputNumber
                  :tableFormat="true"
                  :borderBlue="!newSelectedStrategy.fixedCost"
                  :borderYellow="
                    newSelectedStrategy.warning !== null &&
                      newSelectedStrategy.warning !== undefined &&
                      newSelectedStrategy.warning !== ''
                  "
                  v-if="newSelectedStrategy.calculated"
                  :value="newSelectedStrategy.cost"
                  @input="(val) => onUserCostChange(val, 1)"
              /></span>
            </td>
            <td v-if="baseCurrency.isCurrency" class="text-right mr-1">
              Cost ({{ baseCurrency.foreign }}):
            </td>
            <td v-if="baseCurrency.isCurrency">
              <span v-if="newSelectedStrategy.cost === null">
                <div class="opt-table-txt">0</div>
              </span>
              <span v-else
                ><InputNumber
                  :tableFormat="true"
                  :borderBlue="!newSelectedStrategy.fixedCost"
                  :borderYellow="
                    newSelectedStrategy.warning !== null &&
                      newSelectedStrategy.warning !== undefined &&
                      newSelectedStrategy.warning !== ''
                  "
                  v-if="newSelectedStrategy.calculated"
                  :value="secondCost"
                  @input="(val) => onUserCostChange(val, 2)"
              /></span>
            </td>
            <td class="text-center" colspan="2" v-show="!isFwdOrFuture">
              <label
                :for="'cost'"
                class="toggle__button_nav"
                style="height: 100%; margin: auto!important; width: 100%;"
                :class="{ actives: !newSelectedStrategy.fixedCost }"
              >
                <input
                  type="checkbox"
                  @click="onClientCostSelect"
                  :id="'cost'"
                  v-model="newSelectedStrategy.fixedCost"
                />
                <span class="toggle__switch_nav" style="width: 100%;">
                  <div class="row f-row justify-content-center">
                    <div
                      class="col col-6 txt-label-primary-2 text-center"
                      style="font-size: 0.75rem!important;"
                    >
                      Find Strike
                    </div>
                    <div
                      class="col col-6 txt-label-primary-2 text-center"
                      style="font-size: 0.75rem!important;"
                    >
                      Calculate premium
                    </div>
                  </div>
                </span>
              </label>
              <span>
                <i
                  v-show="
                    newSelectedStrategy.warning !== null &&
                      newSelectedStrategy.warning !== undefined &&
                      newSelectedStrategy.warning !== ''
                  "
                  class="fa fa-warning warn-my-data ml-3"
                  @mouseover="onHoverWarningQuestion(true)"
                  @mouseleave="onHoverWarningQuestion(false)"
                ></i>
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- ======================= SECOND TABLE ======================= -->
      <table
        class="table table-sm table-borderless opt-table"
        style="width: 100%;"
      >
        <thead>
          <tr>
            <td style="width: 30px;" class="text-center">#</td>
            <td>Position</td>
            <td>Derivative</td>
            <td>Strike</td>
            <td>Same strike?</td>
            <td>Option type</td>
            <td>Barrier</td>
            <td>By changing</td>
            <td colspan="2">Instructions</td>
          </tr>
        </thead>

        <!-- ======================= FIRST LEG ======================= -->
        <tbody>
          <tr>
            <td style="width: 30px;" class="text-center">
              <div class="opt-table-txt">1</div>
            </td>
            <th>
              <div class="opt-table-txt">
                {{
                  newSelectedStrategy.leg1.substring(0, 1) === "+"
                    ? "LONG"
                    : "SHORT"
                }}
              </div>
            </th>
            <th>
              <div class="opt-table-txt">
                {{ newSelectedStrategy.leg1.substring(2) }}
              </div>
            </th>
            <td>
              <InputNumber
                :tableFormat="true"
                :borderBlue="
                  newSelectedStrategy.objectiveLeg === 1 && !isFwdOrFuture
                "
                :deactivate="isFwdOrFuture"
                v-if="newSelectedStrategy.calculated"
                :value="newSelectedStrategy.strike1"
                @input="(val) => onUserStrike1Change(val)"
              />
            </td>
            <td class="text-center">
              <label
                v-if="!isFwdOrFuture"
                :for="'leg1'"
                class="toggle__button_rt"
                style="height: 100%; margin: auto!important; width: 100%;"
                :class="{ actives: selectedStrip1 }"
              >
                <input
                  type="checkbox"
                  @click="onClientStrip1Select"
                  :id="'leg1'"
                  v-model="selectedStrip1"
                />
                <span class="toggle__switch_rt" style="width: 100%;">
                  <div class="row f-row justify-content-center">
                    <div
                      class="col col-6 txt-label-primary-2 text-center"
                      style="font-size: 0.75rem!important;"
                    >
                      YES
                    </div>
                    <div
                      class="col col-6 txt-label-primary-2 text-center"
                      style="font-size: 0.75rem!important;"
                    >
                      NO
                    </div>
                  </div>
                </span>
              </label>
              <span v-else>
                <div class="opt-table-txt">N.A.</div>
              </span>
            </td>
            <td>
              <div class="col selectDiv v-align" v-if="!isFwdOrFuture">
                <select
                  class="dropdown-form dropdown-calc"
                  v-model="newSelectedStrategy.derivative1"
                  @change="onChangedDerivative(1)"
                >
                  <option :value="1">EUROPEAN</option>
                  <option :value="4">UP AND IN</option>
                  <option :value="5">UP AND OUT</option>
                  <option :value="6">DOWN AND IN</option>
                  <option :value="7">DOWN AND OUT</option>
                </select>
              </div>
              <span v-else>
                <div class="opt-table-txt">N.A.</div>
              </span>
            </td>
            <td>
              <span
                v-if="newSelectedStrategy.derivative1 < 4 && !isFwdOrFuture"
              >
                <div class="opt-table-txt">NONE</div>
              </span>
              <span
                v-else-if="
                  newSelectedStrategy.barrier1 === null || isFwdOrFuture
                "
              >
                <div class="opt-table-txt">N.A.</div>
              </span>
              <span v-else
                ><InputNumber
                  :tableFormat="true"
                  v-if="newSelectedStrategy.calculated"
                  v-model="newSelectedStrategy.barrier1"
              /></span>
            </td>
            <td>
              <label class="container" v-if="!isFwdOrFuture">
                <input
                  type="radio"
                  name="radio"
                  :value="1"
                  @click="onObjectiveLeg(1)"
                  v-model="newSelectedStrategy.objectiveLeg"
                />
                <span class="checkmark"></span>
              </label>
              <span v-else>
                <div class="opt-table-txt">N.A.</div>
              </span>
            </td>
            <td
              colspan="2"
              :rowspan="newSelectedStrategy.numLegs"
              v-bind:class="[
                newSelectedStrategy.numLegs === 1 ? '' : 'table-txt-bdr-l',
              ]"
            >
              <div
                class="opt-table-txt"
                v-bind:class="[
                  newSelectedStrategy.numLegs === 1
                    ? ''
                    : newSelectedStrategy.numLegs === 2
                    ? 'opt-table-txt-h2'
                    : newSelectedStrategy.numLegs === 3
                    ? 'opt-table-txt-h3'
                    : 'opt-table-txt-h4',
                ]"
              >
                <span v-if="isFwdOrFuture">Not available</span>
                <span
                  v-else-if="newSelectedStrategy.numLegs === 1"
                  style="font-size: 1.3rem;"
                >
                  <i
                    class="fa fa-question-circle showHelp"
                    aria-hidden="true"
                    @mouseover="onHoverInstructionsQuestion(true)"
                    @mouseleave="onHoverInstructionsQuestion(false)"
                  ></i>
                </span>
                <span v-else style="margin: 0 5% 0 5%;">{{
                  instructionsTxt
                }}</span>
              </div>
            </td>
          </tr>

          <!-- ======================= SECOND LEG ======================= -->
          <tr v-show="newSelectedStrategy.numLegs >= 2">
            <td style="width: 30px;" class="text-center">
              <div class="opt-table-txt">2</div>
            </td>
            <td>
              <div class="opt-table-txt">
                {{
                  newSelectedStrategy.leg2 === null
                    ? ""
                    : newSelectedStrategy.leg2.substring(0, 1) === "+"
                    ? "LONG"
                    : "SHORT"
                }}
              </div>
            </td>
            <td>
              <div class="opt-table-txt">
                {{
                  newSelectedStrategy.leg2 === null
                    ? ""
                    : newSelectedStrategy.leg2.substring(2)
                }}
              </div>
            </td>
            <td>
              <span v-if="newSelectedStrategy.strike2 === null">OK</span>
              <span v-else
                ><InputNumber
                  :tableFormat="true"
                  :borderBlue="newSelectedStrategy.objectiveLeg === 2"
                  v-if="newSelectedStrategy.calculated"
                  :value="newSelectedStrategy.strike2"
                  @input="(val) => onUserStrike2Change(val)"
              /></span>
            </td>
            <td class="text-center">
              <label
                :for="'leg2'"
                class="toggle__button_rt"
                style="height: 100%; margin: auto!important; width: 100%;"
                :class="{ actives: selectedStrip2 }"
              >
                <input
                  type="checkbox"
                  @click="onClientStrip2Select"
                  :id="'leg2'"
                  v-model="selectedStrip2"
                />
                <span class="toggle__switch_rt" style="width: 100%;">
                  <div class="row f-row justify-content-center">
                    <div
                      class="col col-6 txt-label-primary-2 text-center"
                      style="font-size: 0.75rem!important;"
                    >
                      YES
                    </div>
                    <div
                      class="col col-6 txt-label-primary-2 text-center"
                      style="font-size: 0.75rem!important;"
                    >
                      NO
                    </div>
                  </div>
                </span>
              </label>
            </td>
            <td>
              <div class="col selectDiv v-align">
                <select
                  class="dropdown-form dropdown-calc"
                  v-model="newSelectedStrategy.derivative2"
                  @change="onChangedDerivative(2)"
                >
                  <option :value="1">EUROPEAN</option>
                  <option :value="4">UP AND IN</option>
                  <option :value="5">UP AND OUT</option>
                  <option :value="6">DOWN AND IN</option>
                  <option :value="7">DOWN AND OUT</option>
                </select>
              </div>
            </td>
            <td>
              <span v-if="newSelectedStrategy.derivative2 < 4">
                <div class="opt-table-txt">NONE</div>
              </span>
              <span v-else-if="newSelectedStrategy.barrier2 === null">
                <div class="opt-table-txt">N.A.</div>
              </span>
              <span v-else
                ><InputNumber
                  :tableFormat="true"
                  v-if="newSelectedStrategy.calculated"
                  v-model="newSelectedStrategy.barrier2"
              /></span>
            </td>
            <td>
              <label class="container">
                <input
                  type="radio"
                  name="radio"
                  :value="2"
                  @click="onObjectiveLeg(2)"
                  v-model="newSelectedStrategy.objectiveLeg"
                />
                <span class="checkmark"></span>
              </label>
            </td>
          </tr>

          <!-- ======================= THIRD LEG ======================= -->
          <tr v-show="newSelectedStrategy.numLegs >= 3">
            <td style="width: 30px;" class="text-center">
              <div class="opt-table-txt">3</div>
            </td>
            <td>
              <div class="opt-table-txt">
                {{
                  newSelectedStrategy.leg3 === null
                    ? ""
                    : newSelectedStrategy.leg3.substring(0, 1) === "+"
                    ? "LONG"
                    : "SHORT"
                }}
              </div>
            </td>
            <td>
              <div class="opt-table-txt">
                {{
                  newSelectedStrategy.leg3 === null
                    ? ""
                    : newSelectedStrategy.leg3.substring(2)
                }}
              </div>
            </td>
            <td>
              <span v-if="newSelectedStrategy.strike3 === null">OK</span>
              <span v-else
                ><InputNumber
                  :tableFormat="true"
                  :borderBlue="newSelectedStrategy.objectiveLeg === 3"
                  v-if="newSelectedStrategy.calculated"
                  :value="newSelectedStrategy.strike3"
                  @input="(val) => onUserStrike3Change(val)"
              /></span>
            </td>
            <td class="text-center">
              <label
                :for="'leg3'"
                class="toggle__button_rt"
                style="height: 100%; margin: auto!important; width: 100%;"
                :class="{ actives: selectedStrip3 }"
              >
                <input
                  type="checkbox"
                  @click="onClientStrip3Select"
                  :id="'leg3'"
                  v-model="selectedStrip3"
                />
                <span class="toggle__switch_rt" style="width: 100%;">
                  <div class="row f-row justify-content-center">
                    <div
                      class="col col-6 txt-label-primary-2 text-center"
                      style="font-size: 0.75rem!important;"
                    >
                      YES
                    </div>
                    <div
                      class="col col-6 txt-label-primary-2 text-center"
                      style="font-size: 0.75rem!important;"
                    >
                      NO
                    </div>
                  </div>
                </span>
              </label>
            </td>
            <td>
              <div class="col selectDiv v-align">
                <select
                  class="dropdown-form dropdown-calc"
                  v-model="newSelectedStrategy.derivative3"
                  @change="onChangedDerivative(3)"
                >
                  <option :value="1">EUROPEAN</option>
                  <option :value="4">UP AND IN</option>
                  <option :value="5">UP AND OUT</option>
                  <option :value="6">DOWN AND IN</option>
                  <option :value="7">DOWN AND OUT</option>
                </select>
              </div>
            </td>
            <td>
              <span v-if="newSelectedStrategy.derivative3 < 4">
                <div class="opt-table-txt">NONE</div>
              </span>
              <span v-else-if="newSelectedStrategy.barrier3 === null">
                <div class="opt-table-txt">N.A.</div>
              </span>
              <span v-else
                ><InputNumber
                  :tableFormat="true"
                  v-if="newSelectedStrategy.calculated"
                  v-model="newSelectedStrategy.barrier3"
              /></span>
            </td>
            <td>
              <label class="container">
                <input
                  type="radio"
                  name="radio"
                  :value="3"
                  @click="onObjectiveLeg(3)"
                  v-model="newSelectedStrategy.objectiveLeg"
                />
                <span class="checkmark"></span>
              </label>
            </td>
          </tr>

          <!-- ======================= FOURTH LEG ======================= -->
          <tr v-show="newSelectedStrategy.numLegs >= 4">
            <td style="width: 30px;" class="text-center">
              <div class="opt-table-txt">4</div>
            </td>
            <td>
              <div class="opt-table-txt">
                {{
                  newSelectedStrategy.leg4 === null
                    ? ""
                    : newSelectedStrategy.leg4.substring(0, 1) === "+"
                    ? "LONG"
                    : "SHORT"
                }}
              </div>
            </td>
            <td>
              <div class="opt-table-txt">
                {{
                  newSelectedStrategy.leg4 === null
                    ? ""
                    : newSelectedStrategy.leg4.substring(2)
                }}
              </div>
            </td>
            <td>
              <span v-if="newSelectedStrategy.strike4 === null">OK</span>
              <span v-else
                ><InputNumber
                  :tableFormat="true"
                  :borderBlue="newSelectedStrategy.objectiveLeg === 4"
                  v-if="newSelectedStrategy.calculated"
                  :value="newSelectedStrategy.strike4"
                  @input="(val) => onUserStrike4Change(val)"
              /></span>
            </td>
            <td class="text-center">
              <label
                :for="'leg4'"
                class="toggle__button_rt"
                style="height: 100%; margin: auto!important; width: 100%;"
                :class="{ actives: selectedStrip4 }"
              >
                <input
                  type="checkbox"
                  @click="onClientStrip4Select"
                  :id="'leg4'"
                  v-model="selectedStrip4"
                />
                <span class="toggle__switch_rt" style="width: 100%;">
                  <div class="row f-row justify-content-center">
                    <div
                      class="col col-6 txt-label-primary-2 text-center"
                      style="font-size: 0.75rem!important;"
                    >
                      YES
                    </div>
                    <div
                      class="col col-6 txt-label-primary-2 text-center"
                      style="font-size: 0.75rem!important;"
                    >
                      NO
                    </div>
                  </div>
                </span>
              </label>
            </td>
            <td>
              <div class="col selectDiv v-align">
                <select
                  class="dropdown-form dropdown-calc"
                  v-model="newSelectedStrategy.derivative4"
                  @change="onChangedDerivative(4)"
                >
                  <option :value="1">EUROPEAN</option>
                  <option :value="4">UP AND IN</option>
                  <option :value="5">UP AND OUT</option>
                  <option :value="6">DOWN AND IN</option>
                  <option :value="7">DOWN AND OUT</option>
                </select>
              </div>
            </td>
            <td>
              <span v-if="newSelectedStrategy.derivative4 < 4">
                <div class="opt-table-txt">NONE</div>
              </span>
              <span v-else-if="newSelectedStrategy.barrier4 === null">
                <div class="opt-table-txt">N.A.</div>
              </span>
              <span v-else
                ><InputNumber
                  :tableFormat="true"
                  v-if="newSelectedStrategy.calculated"
                  v-model="newSelectedStrategy.barrier4"
              /></span>
            </td>
            <td>
              <label class="container">
                <input
                  type="radio"
                  name="radio"
                  :value="4"
                  @click="onObjectiveLeg(4)"
                  v-model="newSelectedStrategy.objectiveLeg"
                />
                <span class="checkmark"></span>
              </label>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="instructions-div text-center" v-if="showExplainDiv">
        {{ instructionsTxt }}
      </div>
      <div class="instructions-div text-center" v-if="showWarningDiv">
        {{ newSelectedStrategy.warning }}
      </div>
    </div>
  </div>
</template>

<script>
import { getObjectiveLeg } from "@/_core/data/Optimizer";
import InputNumber from "@/components/InputNumber";
import QSLoading from "@/components/QSLoading.vue";

export default {
  name: "Calculator",
  components: {
    InputNumber,
    QSLoading,
  },
  props: {
    baseCurrency: { required: true, default: () => [] },
    carouselPage: { required: true, default: 0 },
    colorTheme: { required: true, type: Boolean, default: true },
    selectedStrategy: { required: true, default: () => [] },
    showCalculator: { required: true },
    spot: { required: true, default: 0 },
  },
  data() {
    return {
      newSelectedStrategy: [],
      showExplainDiv: false,
      showWarningDiv: false,
    };
  },
  created() {
    this.newSelectedStrategy = this.selectedStrategy;
  },
  watch: {
    selectedStrategy(val) {
      this.newSelectedStrategy = val;
    },
  },
  computed: {
    selectedCostGoalSeek: {
      get() {
        return this.newSelectedStrategy.isStrip1 === false;
      },
      set() {
        return false;
      },
    },
    selectedStrip1: {
      get() {
        return this.newSelectedStrategy.isStrip1 === false;
      },
      set() {
        return false;
      },
    },
    selectedStrip2: {
      get() {
        return this.newSelectedStrategy.isStrip2 === false;
      },
      set() {
        return false;
      },
    },
    selectedStrip3: {
      get() {
        return this.newSelectedStrategy.isStrip3 === false;
      },
      set() {
        return false;
      },
    },
    selectedStrip4: {
      get() {
        return this.newSelectedStrategy.isStrip4 === false;
      },
      set() {
        return false;
      },
    },
    isFwdOrFuture() {
      return (
        this.newSelectedStrategy.name === "LONG FORWARD" ||
        this.newSelectedStrategy.name === "SHORT FORWARD" ||
        this.newSelectedStrategy.name === "LONG FUTURE" ||
        this.newSelectedStrategy.name === "SHORT FUTURE"
      );
    },
    secondCost() {
      return this.newSelectedStrategy.cost / this.spot;
    },
    instructionsTxt() {
      let txt;
      if (this.isFwdOrFuture) {
        txt = "";
      } else if (this.newSelectedStrategy.fixedCost) {
        txt =
          "Change any field, and the calculator will automatically adjust the cost of the strategy by modifying the strike price of Derivative # " +
          this.newSelectedStrategy.objectiveLeg +
          ".";
      } else {
        txt =
          "Change any field, and the calculator will compute the strategy's cost.";
      }
      return txt;
    },
  },
  methods: {
    // === send to back for calculations ===
    onUserValuate() {
      this.$emit("eventOnUserValuate", this.newSelectedStrategy.id);
    },
    onUserCostChange(val, curr) {
      if (curr === 2) {
        val *= this.spot;
      }
      this.newSelectedStrategy.cost = val;
      if (this.newSelectedStrategy.fixedCost === false) {
        this.newSelectedStrategy.fixedCost = true;
        this.newSelectedStrategy.objectiveLeg = 1;
      }
      this.$emit("eventOnUserCostChange", {
        idx: this.newSelectedStrategy.id,
        cost: val,
        strategy: this.newSelectedStrategy,
        isStrip: getObjectiveLeg(
          this.newSelectedStrategy.objectiveLeg,
          this.newSelectedStrategy,
        ),
        editedLeg: 0,
        editedIsStrip: null,
        editedCurrAve: 0,
        editedLegStripChanged: false,
      });
    },
    // === other functions ===
    onObjectiveLeg(val) {
      if (this.newSelectedStrategy.objectiveLeg === val) {
        this.newSelectedStrategy.objectiveLeg = 0;
        this.newSelectedStrategy.fixedCost = false;
      } else {
        this.newSelectedStrategy.objectiveLeg = val;
        this.newSelectedStrategy.fixedCost = true;
      }
    },
    onClientCostSelect() {
      if (this.newSelectedStrategy.fixedCost) {
        this.newSelectedStrategy.objectiveLeg = 0;
      } else {
        if (this.newSelectedStrategy.objectiveLeg === 0) {
          this.newSelectedStrategy.objectiveLeg = 1;
        }
      }
    },
    onUserStrike1Change(val) {
      this.newSelectedStrategy.strike1 = val;
      if (this.newSelectedStrategy.first_second_strike_equal) {
        this.newSelectedStrategy.strike2 = this.newSelectedStrategy.strike1;
        if (this.newSelectedStrategy.fixedCost) {
          if (
            this.newSelectedStrategy.objectiveLeg === 1 ||
            this.newSelectedStrategy.objectiveLeg === 2
          ) {
            if (this.newSelectedStrategy.numLegs >= 3) {
              this.newSelectedStrategy.objectiveLeg = 3;
            } else {
              this.newSelectedStrategy.fixedCost = false;
              this.newSelectedStrategy.objectiveLeg = 0;
            }
          }
        }
      } else {
        if (this.newSelectedStrategy.fixedCost) {
          if (this.newSelectedStrategy.objectiveLeg === 1) {
            if (this.newSelectedStrategy.numLegs >= 2) {
              this.newSelectedStrategy.objectiveLeg = 2;
            } else {
              this.newSelectedStrategy.fixedCost = false;
              this.newSelectedStrategy.objectiveLeg = 0;
            }
          }
        }
      }
      this.$emit("eventOnUserCostChange", {
        idx: this.newSelectedStrategy.id,
        cost: this.newSelectedStrategy.cost,
        strategy: this.newSelectedStrategy,
        isStrip: getObjectiveLeg(
          this.newSelectedStrategy.objectiveLeg,
          this.newSelectedStrategy,
        ),
        editedLeg: 1,
        editedIsStrip: this.newSelectedStrategy.isStrip1,
        editedCurrAve: this.newSelectedStrategy.strike1,
        editedLegStripChanged: true,
      });
    },
    onUserStrike2Change(val) {
      this.newSelectedStrategy.strike2 = val;
      if (this.newSelectedStrategy.first_second_strike_equal) {
        this.newSelectedStrategy.strike1 = this.newSelectedStrategy.strike2;
        if (this.newSelectedStrategy.fixedCost) {
          if (
            this.newSelectedStrategy.objectiveLeg === 1 ||
            this.newSelectedStrategy.objectiveLeg === 2
          ) {
            if (this.newSelectedStrategy.numLegs >= 3) {
              this.newSelectedStrategy.objectiveLeg = 3;
            } else {
              this.newSelectedStrategy.fixedCost = false;
              this.newSelectedStrategy.objectiveLeg = 0;
            }
          }
        }
      } else {
        if (this.newSelectedStrategy.fixedCost) {
          if (this.newSelectedStrategy.objectiveLeg === 2) {
            this.newSelectedStrategy.objectiveLeg = 1;
          }
        }
      }
      this.$emit("eventOnUserCostChange", {
        idx: this.newSelectedStrategy.id,
        cost: this.newSelectedStrategy.cost,
        strategy: this.newSelectedStrategy,
        isStrip: getObjectiveLeg(
          this.newSelectedStrategy.objectiveLeg,
          this.newSelectedStrategy,
        ),
        editedLeg: 2,
        editedIsStrip: this.newSelectedStrategy.isStrip2,
        editedCurrAve: this.newSelectedStrategy.strike2,
        editedLegStripChanged: true,
      });
    },
    onUserStrike3Change(val) {
      this.newSelectedStrategy.strike3 = val;
      if (this.newSelectedStrategy.fixedCost) {
        if (this.newSelectedStrategy.objectiveLeg === 3) {
          this.newSelectedStrategy.objectiveLeg = 1;
        }
      }
      this.$emit("eventOnUserCostChange", {
        idx: this.newSelectedStrategy.id,
        cost: this.newSelectedStrategy.cost,
        strategy: this.newSelectedStrategy,
        isStrip: getObjectiveLeg(
          this.newSelectedStrategy.objectiveLeg,
          this.newSelectedStrategy,
        ),
        editedLeg: 3,
        editedIsStrip: this.newSelectedStrategy.isStrip3,
        editedCurrAve: this.newSelectedStrategy.strike3,
        editedLegStripChanged: true,
      });
    },
    onUserStrike4Change(val) {
      this.newSelectedStrategy.strike4 = val;
      if (this.newSelectedStrategy.fixedCost) {
        if (this.newSelectedStrategy.objectiveLeg === 4) {
          this.newSelectedStrategy.objectiveLeg = 1;
        }
      }
      this.$emit("eventOnUserCostChange", {
        idx: this.newSelectedStrategy.id,
        cost: this.newSelectedStrategy.cost,
        strategy: this.newSelectedStrategy,
        isStrip: getObjectiveLeg(
          this.newSelectedStrategy.objectiveLeg,
          this.newSelectedStrategy,
        ),
        editedLeg: 4,
        editedIsStrip: this.newSelectedStrategy.isStrip4,
        editedCurrAve: this.newSelectedStrategy.strike4,
        editedLegStripChanged: true,
      });
    },
    onClientStrip1Select() {
      this.newSelectedStrategy.isStrip1 = !this.newSelectedStrategy.isStrip1;
      if (this.newSelectedStrategy.first_second_strike_equal) {
        this.newSelectedStrategy.isStrip2 = this.newSelectedStrategy.isStrip1;
      }
      this.$emit("eventOnUserCostChange", {
        idx: this.newSelectedStrategy.id,
        cost: this.newSelectedStrategy.cost,
        strategy: this.newSelectedStrategy,
        isStrip: getObjectiveLeg(
          this.newSelectedStrategy.objectiveLeg,
          this.newSelectedStrategy,
        ),
        editedLeg: 1,
        editedIsStrip: this.newSelectedStrategy.isStrip1,
        editedCurrAve: this.newSelectedStrategy.strike1,
        editedLegStripChanged: true,
      });
    },
    onClientStrip2Select() {
      this.newSelectedStrategy.isStrip2 = !this.newSelectedStrategy.isStrip2;
      if (this.newSelectedStrategy.first_second_strike_equal) {
        this.newSelectedStrategy.isStrip1 = this.newSelectedStrategy.isStrip2;
      }
      this.$emit("eventOnUserCostChange", {
        idx: this.newSelectedStrategy.id,
        cost: this.newSelectedStrategy.cost,
        strategy: this.newSelectedStrategy,
        isStrip: getObjectiveLeg(
          this.newSelectedStrategy.objectiveLeg,
          this.newSelectedStrategy,
        ),
        editedLeg: 2,
        editedIsStrip: this.newSelectedStrategy.isStrip2,
        editedCurrAve: this.newSelectedStrategy.strike2,
        editedLegStripChanged: true,
      });
    },
    onClientStrip3Select() {
      this.newSelectedStrategy.isStrip3 = !this.newSelectedStrategy.isStrip3;
      this.$emit("eventOnUserCostChange", {
        idx: this.newSelectedStrategy.id,
        cost: this.newSelectedStrategy.cost,
        strategy: this.newSelectedStrategy,
        isStrip: getObjectiveLeg(
          this.newSelectedStrategy.objectiveLeg,
          this.newSelectedStrategy,
        ),
        editedLeg: 3,
        editedIsStrip: this.newSelectedStrategy.isStrip3,
        editedCurrAve: this.newSelectedStrategy.strike3,
        editedLegStripChanged: true,
      });
    },
    onClientStrip4Select() {
      this.newSelectedStrategy.isStrip4 = !this.newSelectedStrategy.isStrip4;
      this.$emit("eventOnUserCostChange", {
        idx: this.newSelectedStrategy.id,
        cost: this.newSelectedStrategy.cost,
        strategy: this.newSelectedStrategy,
        isStrip: getObjectiveLeg(
          this.newSelectedStrategy.objectiveLeg,
          this.newSelectedStrategy,
        ),
        editedLeg: 4,
        editedIsStrip: this.newSelectedStrategy.isStrip4,
        editedCurrAve: this.newSelectedStrategy.strike4,
        editedLegStripChanged: true,
      });
    },
    onChangedDerivative(idx) {
      if (idx === 1) {
        console.log(this.newSelectedStrategy.derivative1);
      } else if (idx === 2) {
        console.log(this.newSelectedStrategy.derivative2);
      } else if (idx === 3) {
        console.log(this.newSelectedStrategy.derivative3);
      } else if (idx === 4) {
        console.log(this.newSelectedStrategy.derivative4);
      }
    },
    onHoverInstructionsQuestion(val) {
      this.showExplainDiv = val;
    },
    onHoverWarningQuestion(val) {
      this.showWarningDiv = val;
    },
  },
};
</script>

<style scoped>
/* toggle yes no */
.toggle__button_rt .toggle__switch_rt::after,
.toggle__button_rt .toggle__switch_rt::before {
  content: "YES";
  font-size: 0.8rem !important;
  padding: 0 !important;
}
.actives .toggle__switch_rt::before,
.actives .toggle__switch_rt::after {
  content: "NO";
}
/* toggle GOAL SEEK / CALCULATE */
.toggle__button_nav .toggle__switch_nav::after,
.toggle__button_nav .toggle__switch_nav::before {
  content: "Find Strike";
  font-size: 0.8rem !important;
  padding: 0 !important;
}
.actives .toggle__switch_nav::before,
.actives .toggle__switch_nav::after {
  content: "Calculate premium";
}

/* checkboxes */
.container {
  width: 100%;
  display: block;
  position: relative;
  top: -6px;
  left: calc(50% - 10px);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
/* Hide the browser's default radio button */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: var(--lightbackground3);
  border-radius: 50%;
}
/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: var(--lightbackground4);
}
/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: var(--lightbackground4);
}
/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}
/* Style the indicator (dot/circle) */
.container .checkmark:after {
  top: 6px;
  left: 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--expo);
}
</style>
